
import { Component, Prop, Vue } from 'vue-property-decorator';

export const actionButtonTones = ['primary', 'neutral'] as const;

@Component({ inheritAttrs: false })
export default class ActionButton extends Vue {
  @Prop({ default: 'neutral' }) tone!: typeof actionButtonTones[number];
}
